import axios, { endpoints } from "src/lib/axios";

export interface EmailIntegrationInitResponse {
    providerTyp: string;
    oauthUrl?: string;
}

export interface ImapSetupRequest {
    emailAdress: string;
    imapHost: string;
    imapLosenord: string;
}

export interface InkommandeEmail {
    id: string;
    avsandare: string;
    amne: string;
    brodtext: string;
    htmlContent?: string;
    mottagenDatum: string;
    bilagor?: {
        id: string;
        filnamn: string;
        url: string;
    }[];
}

export interface EmailIntegrationStatus {
    connected: boolean;
    providerTyp?: string;
    emailAdress?: string;
}

export class EmailIntegrationService {
    static async initieraIntegration(
        orgId: string,
        emailAdress: string
    ): Promise<EmailIntegrationInitResponse> {
        const response = await axios.post(
            `/api/v1/organisationer/${orgId}/email-integration/initiera`,
            { emailAdress }
        );
        return response.data;
    }

    /**
     * `state` måste skickas vidare oförändrat — backend har genererat det, bundit det till
     * organisationen och avvisar callbacken utan det (CSRF-skydd).
     */
    static async slutförOauth(orgId: string, code: string, state: string): Promise<void> {
        await axios.get(
            `/api/v1/organisationer/${orgId}/email-integration/oauth2callback` +
            `?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`
        );
    }

    static async sparaImap(orgId: string, request: ImapSetupRequest): Promise<void> {
        await axios.post(`/api/v1/organisationer/${orgId}/email-integration/imap`, request);
    }

    static async hämtaMottagnaEmail(orgId: string): Promise<InkommandeEmail[]> {
        const response = await axios.get(`/api/v1/organisationer/${orgId}/mottagna-email`);
        return response.data;
    }

    static async hämtaStatus(orgId: string): Promise<EmailIntegrationStatus> {
        const response = await axios.get(`/api/v1/organisationer/${orgId}/email-integration/status`);
        return response.data;
    }

    static async synkroniseraNu(orgId: string): Promise<void> {
        await axios.post(`/api/v1/organisationer/${orgId}/email-integration/synkronisera`);
    }
}
